export default class MultiselectInput extends React.Component {
  constructor (props) {
    super(props)

    this.element = React.createRef()
  }

  componentDidMount () {
    $(this.element.current).select2()

    $(this.element.current).on('change', (event) => {
      this.props.onSelect({ val: event.val })
    })
  }

  render () {
    return (
      <select
ref={this.element}
        multiple
        className='form-control'
        data-placeholder={this.props.placeholder}
      >
        {this._renderOptions()}
      </select>
    )
  }

  _renderOptions () {
    return this.props.options.map((option, index) => {
      if (_.isArray(option)) {
        return <option key={`option-${index}`} value={option[1]}>{option[0]}</option>
      }

      if (_.isString(option)) {
        return <option key={`option-${index}`} value={option}>{option}</option>
      }
    })
  }
}

MultiselectInput.propTypes = {
  name: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.string]), // [[text, value], [text, value]]
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string])
}
